var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOffsetDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "2 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3.5C4.61929 3.5 3.5 4.61929 3.5 6V7.5V14C3.5 15.3807 4.61929 16.5 6 16.5H8.5H12.0606C12.0409 16.1918 12.0358 15.8515 12.0535 15.5H9V8H19.5V11.2703C19.8247 11.0957 20.1569 10.8689 20.5 10.5744V7.5V6C20.5 4.61929 19.3807 3.5 18 3.5H6ZM4.5 6C4.5 5.17157 5.17157 4.5 6 4.5H18C18.8284 4.5 19.5 5.17157 19.5 6V7H8.5H4.5V6ZM8 8V15.5H6C5.17157 15.5 4.5 14.8284 4.5 14V8H8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6007 9.2978C21.5343 9.16512 21.4017 9.07666 21.269 9.07666C21.1584 9.07666 21.0478 9.143 20.9594 9.27569C20.2738 10.4699 19.0575 11.1996 17.6643 11.1996H15.8952C13.551 11.1996 11.6492 13.1015 11.6492 15.4456C11.6492 15.8437 11.6934 16.2196 11.804 16.5956C10.1675 18.0109 9.54833 19.6695 9.54833 19.7137C9.45988 19.9791 9.59256 20.2887 9.88005 20.3771C10.1897 20.4877 10.455 20.2887 10.5435 20.0454C10.5656 20.0233 11.0079 18.7849 12.2242 17.6128C13.0645 19.006 14.6346 19.8464 16.3375 19.6695C19.8094 19.4262 22.2641 16.3081 22.2641 12.5044C22.2641 11.3987 22.0209 10.2487 21.6007 9.2978ZM16.2269 18.6301C14.325 18.8291 13.3299 17.4138 13.0866 16.9273C14.126 16.1975 15.5635 15.6225 17.4874 15.6225C17.7749 15.6225 18.0182 15.4014 18.0182 15.0918C18.0182 14.8043 17.7749 14.561 17.4874 14.561C15.4529 14.561 13.927 15.136 12.7549 15.8879C12.7328 15.7331 12.7107 15.6004 12.7107 15.4456C12.7107 13.6986 14.126 12.2611 15.8952 12.2611H17.6643C18.947 12.2611 20.119 11.7746 21.0257 10.9343C21.1363 11.4429 21.2026 11.9736 21.2026 12.5044C21.2026 15.8437 19.1239 18.4089 16.2269 18.6301Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffsetDashboard);
export default __webpack_public_path__ + "static/media/offset-dashboard.471ce42ccedf067a5a630c04f385f466.svg";
export { ForwardRef as ReactComponent };